'use strict'
const assign = require('lodash.assign')
const bind = require('lodash.bind')
const clone = require('lodash.clone')
const cloneDeep = require('lodash.clonedeep')
const debounce = require('lodash.debounce')
const defer = require('lodash.defer')
const eq = require('lodash.eq')
const filter = require('lodash.filter')
const find = require('lodash.find')
const findKey = require('lodash.findkey')
const flatMap = require('lodash.flatmap')
const flow = require('lodash.flow')
const forEach = require('lodash.foreach')
const forOwn = require('lodash.forown')
const _get = require('lodash.get')
const includes = require('lodash.includes')
const isEmpty = require('lodash.isempty')
const isEqual = require('lodash.isequal')
const map = require('lodash.map')
const omit = require('lodash.omit')
const omitBy = require('lodash.omitby')
const sortBy = require('lodash.sortby')
const pull = require('lodash.pull')
const reduce = require('lodash.reduce')
const reject = require('lodash.reject')
const values = require('lodash.values')

module.exports = {
    assign,
    bind,
    clone,
    cloneDeep,
    debounce,
    defer,
    eq,
    filter,
    find,
    findKey,
    flatMap,
    flow,
    forEach,
    forOwn,
    get: _get,
    includes,
    isEmpty,
    isEqual,
    map,
    omit,
    omitBy,
    sortBy,
    pull,
    reduce,
    reject,
    values,
    noop: () => {}
}



// WEBPACK FOOTER //
// ./lodashParts.js